import React, { useEffect, useRef } from 'react';
import BiddingList from 'components/organisms/bidding_list';
import { useDispatch, useSelector } from 'react-redux';
import { ManagementState, ManagementTypes } from 'store/modules/management_store/types';
import { BiddingState, BiddingTypes } from 'store/modules/bidding_store/types';
import { getBiddings } from 'store/modules/bidding_store/actions';
import { ApplicationState } from 'store';
import { OnlineSearchState } from 'store/modules/online_search_store/types';
import { ProfileState } from 'store/modules/profile_store/types';
import tabId from 'services/tabId';
import { ActivitiesState } from 'store/modules/activities_store/types';
import OrderByFilter from '../order_by_filter';

const FavoritedPage = () => {
  const dispatch = useDispatch();
  const mountedRef = useRef<boolean>(false);

  const { management } = useSelector<ApplicationState, ManagementState>(
    (state) => state.session.management,
  );

  const { onlineSearch } = useSelector<ApplicationState, OnlineSearchState>(
    (state) => state.session.onlineSearch,
  );

  const { activities } = useSelector<ApplicationState, ActivitiesState>(
    (state) => state.storage.activities,
  );

  const { request } = useSelector<ApplicationState, BiddingState>(
    (state) => state.session.biddings,
  );

  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);

  const fetchBiddings = () => {
    if (profile.representant && profile.currentCompany[tabId()] !== profile.company_data.data.id) {
      dispatch(
        getBiddings(
          {
            activities_list: activities[profile.currentCompany[tabId()]],
            page: onlineSearch.currentPage,
            per_page: onlineSearch.postsPerPage,
            favorite_scope: management.filtered_by,
            favorite: true,
            archived: false,
            managed: false,
            order: management.ordered_by,
            order_direction: management.order_direction,
          },
          profile.currentCompany[tabId()],
        ),
      );
      return;
    }

    dispatch(
      getBiddings({
        activities_list: activities[profile.currentCompany[tabId()]],
        page: onlineSearch.currentPage,
        per_page: onlineSearch.postsPerPage,
        favorite_scope: management.filtered_by,
        favorite: true,
        archived: false,
        managed: false,
        order: management.ordered_by,
        order_direction: management.order_direction,
      }),
    );
  };

  useEffect(() => {
    if (mountedRef.current) fetchBiddings();
  }, [
    onlineSearch.currentPage,
    onlineSearch.postsPerPage,
    management.filtered_by,
    management.ordered_by,
    management.order_direction,
    request?.create_managed_bidding,
    profile.currentCompany[tabId()],
  ]);

  useEffect(() => {
    dispatch({ type: BiddingTypes.UPDATE_STORE_FIELDS });
    fetchBiddings();
    mountedRef.current = true;
  }, []);

  const handleOrder = (selected_order: string) => {
    dispatch({ type: ManagementTypes.HANDLE_ORDER, selected_order });
  };

  return (
    <div className="col-md-12 p-0">
      <OrderByFilter
        label="Ordenar por"
        orderedBy={management.ordered_by}
        orderDirection={management.order_direction as 'asc' | 'desc'}
        handle={handleOrder}
      />
      <BiddingList searchBarOpened={false} fromManagement />
    </div>
  );
};

export default FavoritedPage;
